<template>
  <div  class="wl-container" v-html="htmlInfo">
  </div>
</template>
<script>
  import API from '@/api'
  export default {
    name: "csConsult",
    components: {},
    data() {
      return {
        htmlInfo: ""
      }
    },
    mounted() {
      this.initData()
    },
    methods: {
      initData() {
        API.insights.queryConsult().then(res => {
          if (res.code === '1') {
            this.htmlInfo = res.data.htmlInfo.replaceAll('target="_blank"', "").replaceAll('<a', '<a target="_blank"')
          } else {
            this.$message.error(this.$t(res.code));
          }
        })
      }
    }
  }
</script>
<style scoped>
  .wl-container {
    color: #444;
    height: 100%;
    background: #ffffff;
    padding: 15PX;
  }
  ::v-deep .maintitle {
    display: none;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 38px;
    line-height: 1.3;
    font-weight: 500;
    color: #00338d;
    text-align: center;
  }
  ::v-deep .row-same-height {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  ::v-deep .col-md-4 {
    position: relative;
    min-height: 1px;
    padding: 0;
    float: none;
    vertical-align: top;
    overflow: hidden;
    width: 33.33333333%;
    display: table-cell;
  }
  ::v-deep .clearfix {
    position: relative;
  }
  ::v-deep .module-quote {
    padding: 10px;
  }
  ::v-deep .quote-bg {
    background-color: #00338d !important;
    margin: 0 !important;
    padding: 10px;
  }
  ::v-deep .quote-content {
    padding: 15px 20px;
    font-weight: 500!important;
    color: #ffffff;
    word-wrap: break-word;
    font-size: 18px;
    line-height: 1.5;
  }
  ::v-deep .module-bodytext {
    padding: 10px;
  }
  ::v-deep .bodytext-data {
    font-size: 16px;
    line-height: 1.5;
    font-weight: 400;
    color: #333333;
    margin: 7px 0px;
  }
  ::v-deep .module-bodytext ul {
    list-style-position: outside;
    margin: 0 0 10px 20px;
    padding: 0;
    font-size: 16px;
    line-height: 1.5;
    font-weight: 400;
}
  ::v-deep .module-bodytext ul li {
    list-style-type: disc;
    margin: 7px 0px;
  }
  ::v-deep .module-bodytext a:visited {
    color: #005eb8;
  }
  ::v-deep .module-bodytext a:link {
    color: #005eb8;
  }
  ::v-deep .module-bodytext a:hover {
    text-decoration:underline
  }
</style>
